import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { BuyersGroup, BuyersGroupApiService } from '../buyers-groups-item/buyers-groups.service'

@Component({
  selector: 'tc-merge-groups',
  templateUrl: './merge-groups.component.html',
  styleUrls: ['./merge-groups.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MergeGroupsComponent {
  private formBuilder = inject(FormBuilder)
  private dialogRef = inject<MatDialogRef<MergeGroupsComponent>>(MatDialogRef)
  private toaster = inject(ToasterService)
  private buyersGroupService = inject(BuyersGroupApiService)
  private dialogData = inject<{
    groups: BuyersGroup[];
}>(MAT_DIALOG_DATA)

  formGroup: FormGroup
  groups: BuyersGroup[]
  selectedGroupIds = new Set<string>()

  constructor() {
    this.formGroup = this.formBuilder.group({
      name: [null, Validators.required],
    })
    this.groups = this.dialogData.groups
  }

  toggleGroup(groupId: string) {
    if (this.selectedGroupIds.has(groupId)) {
      this.selectedGroupIds.delete(groupId)
    } else {
      this.selectedGroupIds.add(groupId)
    }
  }

  cancel() {
    this.dialogRef.close()
  }

  async merge() {
    if (!this.formGroup.get('name').valid) {
      this.toaster.error('Please provide a group name.')
      return
    }
    if (this.selectedGroupIds.size < 2) {
      this.toaster.error('Please select at least 2 groups to merge.')
      return
    }

    const selectedGroups = this.groups.filter((g) => this.selectedGroupIds.has(g.group_id))
    const mergedBuyers = [...new Set(selectedGroups.flatMap((g) => g.buyers))]

    try {
      const { data } = await this.buyersGroupService.create({
        name: this.formGroup.value.name,
        buyers: mergedBuyers,
      })
      this.toaster.success(`Groups merged successfully into "${data.name}".`)
      this.groups.push(data)
      this.dialogRef.close(data)
    } catch {
      this.toaster.error('Unable to merge groups.')
    }
  }
}